import Polygon from "@arcgis/core/geometry/Polygon";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Sketch from "@arcgis/core/widgets/Sketch";
import { toast } from "react-toastify";
import { obstructionArea, showEsriDrawTool } from "../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { setPolygonDrawn, setTitle, toggleDrawer } from "../../ReduxTool/Slice/Drawer/DrawerReducer";
import { setGeomHeigth } from "../../ReduxTool/Slice/Geometry/GeometryReducer";
import { setIsBuildingDrawn, setroofConfirmed } from "../../ReduxTool/Slice/Map/MapReducer";
import { MAXUSEABLEAREA, MINUSEABLEAREA, TActiveTool } from "../../Utils/Const";
import { pvHandleRoofTop_3d } from "../../Utils/CustomerMaps/GenerateRoof/generate3dRoof";
import globalLayers from "../../Utils/CustomerMaps/Maps/GlobaLMap";
import { loadMultipleModules } from "../../Utils/CustomerMaps/Maps/LazyloadMap";
import { getsimpleFillSymbol, simpleLineSymbol } from "../../Utils/CustomerMaps/MarkerSymbols/MarkerSymbols";
import { store } from "./../../ReduxTool/store/store";
import { bindButtontoSketchObject } from "./bindButtontoSketch_depricated";
import { createCircle, updatingCircleGeometry } from "./createCircle";
import { createPolylinewithCoordinates } from "./createPolyLinefromCoordinates";
import { handlePolygonCreate } from "./createPolygon";
import { handlePolygonGuideEvent, syncPolygonGuides } from "./CustomerSketchDraw/polygonGuideLines";
import { createRectangle } from "./createRectangle";
import { getPointPairsFromRing } from "./getPointPairsFromRing";
import { getGeometryRingPolyline } from "./getRingsLengthPointsGeom";
import { watchLocationMarkerChanges } from "./watchChanges/index";
import { addMarkerToMap } from "../../Utils/Marker/addMarkertoMap";
import { disableSearchWidget } from "../widget/Search/disableSearchWidget";
import { setModalHeaderFooter } from "../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { useRef } from "react";

var lastAddedCoordinates = [] as number[];
var currentCoordinates = [] as number[];

var area = 0



export async function addsketchView() {
    const [GroupLayer, Point, Sketch, GraphicsLayer, SimpleFillSymbol, Measurement, Graphic, geodesicUtils, Polyline, webMercatorUtils, SimpleLineSymbol, SpatialReference, TextSymbol] = await loadMultipleModules(["esri/layers/GroupLayer", "esri/geometry/Point", "esri/widgets/Sketch", "esri/layers/GraphicsLayer", "esri/symbols/SimpleFillSymbol", "esri/widgets/Measurement", "esri/Graphic", "esri/geometry/support/geodesicUtils", "esri/geometry/Polyline", "esri/geometry/support/webMercatorUtils", "esri/symbols/SimpleLineSymbol", "esri/geometry/SpatialReference", "esri/symbols/TextSymbol"])
    const symbolCircle = new SimpleFillSymbol(getsimpleFillSymbol([173, 150, 50, 0.5], [150, 0, 0]))
    // const addressModalTimeoutRef = useRef<NodeJS.Timeout | null>(null)

    if (globalLayers.sketchLayers === null) {
        globalLayers.sketchLayers = new GraphicsLayer({
            title: "sketch-layer",
            id: "sketch-layer",
        });
    }

    if (globalLayers.activeView === "2D") {
        globalLayers.map?.allLayers.forEach(ele => {
            if (ele?.title === "3d") {
                globalLayers.map?.remove(ele);
            }
            if (ele?.title === "RoofTopModule_3d") {
                // ele.visible = false;
                globalLayers.map?.remove(ele);
            }
        });
        const currentModifiedGraohic = globalLayers.selectedGraphic;
        if (currentModifiedGraohic) {
            (globalLayers.sketchLayers?.graphics as any).items.forEach((ele: any) => {
                let graphic3d = currentModifiedGraohic as any;
                // returns true if two given geometries are equal
                if (ele.geometry.type === graphic3d.geometry.type && ele?.title === graphic3d.title) {
                    // const newRings  = globalLayers.removeZfromRings(graphic3d.geometry)
                    ele.geometry.rings = graphic3d.geometry.rings
                }
            })
        }
        globalLayers.map?.add(globalLayers.sketchLayers!)
        if (globalLayers.panles_2d) {
            globalLayers.map?.layers.add(globalLayers.panles_2d);
        }

    } else {
        globalLayers.removeButtonEvents();
        globalLayers.RemoveLayer("RoofTopModule")
        globalLayers.map?.allLayers.forEach(ele => {
            if (ele?.title === "sketch-layer") {
                globalLayers.map?.remove(ele);
            }
            if (ele?.title === "RoofTopModule") {
                globalLayers.map?.remove(ele);
            }
        });

        const currentModifiedGraohic = globalLayers.selectedGraphic
        if (currentModifiedGraohic) {
            (globalLayers.graphic3dLayers?.graphics as any).items.forEach((ele: any) => {
                let graphic2d = currentModifiedGraohic as any;
                if (ele.geometry.type === graphic2d.geometry.type && ele?.title === graphic2d.title) {
                    ele.geometry.rings = graphic2d.geometry.rings;
                }
            })
        }

        if (globalLayers.graphic3dLayers) {
            globalLayers.graphic3dLayers.visible = true
        }

        if (globalLayers.graphic3dLayers) {
            globalLayers.graphic3dLayers.visible = true
            globalLayers.graphic3dLayers.graphics.forEach(graphic => {
                graphic.visible = true
            })
        }

        globalLayers.map?.add(globalLayers.graphic3dLayers!);

        if (globalLayers.polygonGeomforLayout) {
            pvHandleRoofTop_3d(globalLayers.polygonGeomforLayout, globalLayers.elevationP)
        }

    }

    globalLayers.measurement = new Measurement({
        view: globalLayers.view
    })

    let sketchObject = {
        view: globalLayers.view,
        layer: globalLayers.activeView === "2D" ? globalLayers.sketchLayers : globalLayers.graphic3dLayers!,
        creationMode: "update",
        tooltipOptions: { enabled: true },
        labelOptions: { enabled: true },
        multipleSelectionEnabled: true,
        snapOptions: globalLayers.snapOptions,
        enableSnapping: true,
        defaultUpdateOptions: {
            polygonSymbol: new SimpleFillSymbol(
                getsimpleFillSymbol([173, 150, 50, 0.5], [150, 55, 0])
            )
        }
    }

    await globalLayers.skecthVMRefresh(Sketch, sketchObject);
    await watchLocationMarkerChanges()

    // Listen to sketch widget's create event.
    globalLayers.sketchVM.on("create", async function (event) {

        let index = globalLayers.polygonListCounts.length - 1;
        let titleName = globalLayers.polygonListCounts[index]

        if (event.state === "cancel") {
            handlePolygonGuideEvent(event, titleName);
            return;
        }

        const groupLayers = new GroupLayer() as __esri.GroupLayer
        await getVertexAddEvent(event, Point, geodesicUtils, titleName, groupLayers, geometryEngine, Graphic)

        if (event.state === "complete" && event.graphic?.geometry) {
            const shapeType = event.tool;
            event.graphic.symbol = simpleLineSymbol;
            if (shapeType === "polygon") {
                event.graphic.attributes = { type: "polygon", name: 'building' }

                let timeoutRef : NodeJS.Timeout | null = null;
                 timeoutRef =   setTimeout(() => {
                store.dispatch(setModalHeaderFooter({ title: "Site Address",btnTxt: "Save Address",secondaryBtnTxt: "Back",  modalid: "siteaddress", }) );
                 if (timeoutRef !== null) {
                 clearTimeout(timeoutRef)
                    }
                 }, 2000);
                handlePolygonCreate(event, geometryEngine, 'building'+Math.random()*100)
                 }

            
            if (globalLayers.sketchLayers) {
                const existingGraphics = globalLayers.sketchLayers.graphics.filter((graphic: any) => {
                    return graphic.uid === (event.graphic as any).uid;
                });
                if (existingGraphics.length === 0) {
                    // globalLayers.sketchLayers.add(event.graphic);
                }

            }
            if (globalLayers.selectionTool === 'rectangle-selection' && (event.graphic as any).title === 'rectangle') {
                globalLayers.sketchLayers?.graphics.remove(event.graphic);
            }
            let newGraphic = event.graphic;
            await getLengthfromPolygonLines(newGraphic)
            
        }
    });

    // ctrl+z / ctrl+y while drawing are emitted as undo/redo (not as create events)
    globalLayers.sketchVM.on("undo", (event) => syncPolygonGuides(event))
    globalLayers.sketchVM.on("redo", (event) => syncPolygonGuides(event))

    globalLayers.sketchVM.on('update', (event) => {
        const data = store.getState().consumerReducers;
        if(data.roofAnalysis?.selected_project?.projectid){
            globalLayers.sketchVM.cancel();
            return
        }
        const graphic = event.graphics?.[0] as any;
        if (!graphic) return;
        var title = [] as string[];

        
        if (event.state === "start") {            
            // show modald for remve boundry and data if saved else close the modal of selected no
            // check if project os saved then stop the selection of project 
            // if(globalLayers.isSavedProject){
            //     // globalLayers.stopSketch()
            //     store.dispatch(clearBoundryandDataModal(true))
            // }
            

            globalLayers.selectedGraphic = graphic
            title.push(graphic.title);
            // to make polyline and point visible for the selected layer 
            if (event.graphics.length) {
                event.graphics.forEach((layer: any) => {
                    globalLayers.togglePolyline(layer.title, true)
                });
            }
            if (graphic?.attributes?.height) {
                globalLayers.currentSelectedGraphic = graphic?.attributes?.height
                store.dispatch(setGeomHeigth(graphic.attributes.height))
            }
        }

        if (event.state === "complete") {
            event.graphics.forEach(ele => {
                if(ele.geometry && ele.geometry.type === 'polygon'){
                    area = geometryEngine.geodesicArea(ele.geometry as Polygon)
                }
            })
            
            if(area > MAXUSEABLEAREA && event.tool === 'transform' && event.type === 'update'){

                // remove 
                globalLayers.sketchLayers?.graphics.remove(event.graphics![0]);
                globalLayers.removePolyLineswithTitle(title);

                globalLayers.removePolyLineswithTitle('');

                globalLayers.sketchLayers?.graphics.forEach(el => {
                    if(el.geometry.type !== 'polygon'){
                        globalLayers.sketchLayers?.graphics.remove(el);
                    }
                })
                globalLayers.sketchLayers?.removeAll()
                // store.dispatch(obstructionArea(null))
                store.dispatch(setTitle(""))
                store.dispatch(toggleDrawer(false))
                // store.dispatch(resetRoofAnalisisForm());


                if(globalLayers.prevsketchLayers){
                    globalLayers.sketchLayers?.graphics.add(globalLayers.prevsketchLayers)
                }

                store.dispatch(setPolygonDrawn("0"))
                store.dispatch(setIsBuildingDrawn(false))
                globalLayers.isBuildingThere = false
                disableSearchWidget(false)

                addMarkerToMap(store.dispatch)


         
            } else {               
                event.graphics?.forEach((ele: any) => {
                    if (title.includes(ele?.title)) return;
                    title.push(ele.title)
                })
                // make the polyline and point invisible after completion
                if (event.graphics.length) {
                    event.graphics.forEach((layer: any) => {
                        globalLayers.togglePolyline(layer.title, false)
                    })
                }
    
                if (graphic.attributes) {
                    if (graphic.attributes.height) {
                        globalLayers.currentSelectedGraphic = 0
                    }
                }

                if (event.graphics.length) {
                    event.graphics.forEach((layer: any) => {
                        globalLayers.togglePolyline(layer.title, false)
                    })
                }

            }

            // globalLayers.removePolyLineswithTitle('line');
        }

        if (event.toolEventInfo && event.toolEventInfo.type === "selection-change") {
            event.toolEventInfo.added.forEach((ele: any) => {
                title.push(ele?.title)
            })
        }

        if (graphic?.title) {
            if (graphic.title?.includes('circle') === false) {
                globalLayers.lastactiveTool = 'polygon'
            }
        }

        if (event.graphics) {
            if (event.graphics.length === 1) {
                globalLayers.selectedGraphic = graphic
            }
            if (event.graphics.length === 2) {
                event.graphics.forEach(grap => globalLayers.multipleSelectedGraphic.push(grap))
            }
        }

        // only targetting the circle graphic form update sketch object 
        event.graphics.forEach((ele: any) => {
            if (ele?.title?.includes('circle')) {
                if (globalLayers.activeView !== "3D") {
                    updatingCircleGeometry(event, geometryEngine, Polyline, webMercatorUtils, Point, geodesicUtils, Graphic, SimpleFillSymbol)
                }
            } else {
                title.push(ele?.title)
            }
        })

        
        if (event.state === "active" && graphic.geometry) {
            if(!globalLayers.prevsketchLayers){
                globalLayers.prevsketchLayers = event.graphics[0]
            }
            // cal area 
            const geodesicArea = geometryEngine.geodesicArea(event.graphics[0].geometry as Polygon, "square-meters");
            area = geodesicArea as number

          if(area<MAXUSEABLEAREA){
            store.dispatch(obstructionArea({ obsArea: area.toFixed(2) }))
          }

            if(event.toolEventInfo?.type === 'scale-stop' && area > MAXUSEABLEAREA){
                // globalLayers.sketchLayers?.graphics.removeAll();

                // when area become mpre then allowed 

                globalLayers.sketchLayers?.graphics.add(event.graphics![0]);
                globalLayers.removePolyLineswithTitle(title);
                globalLayers.sketchLayers?.graphics.forEach(el => {
                    if(el&& el.geometry && el.geometry.type !== 'polygon'){
                        globalLayers.sketchLayers?.graphics.remove(el);
                    }
                })
                globalLayers.sketchLayers?.removeAll();
                toast.error(`The drawn area must be between ${MINUSEABLEAREA} sq m and ${MAXUSEABLEAREA} sq m.`,{toastId:"customID",autoClose: 7000})
                


            }
            getGeometryRingPolyline(graphic, Point, geodesicUtils, webMercatorUtils, SimpleLineSymbol, Polyline, Graphic, SpatialReference, TextSymbol, geometryEngine, title)
        }
    })

    globalLayers.removeButtonEvents()

    await bindButtontoSketchObject(store.dispatch)

    if(globalLayers.sketchLayers){
        globalLayers.sketchLayers.graphics.on('change', e => {
            if(e.added.length === 0 && e.removed.length > 0){
                const graphic = e.removed.find((removed) => removed?.geometry?.type === 'polygon');
                if(globalLayers.sketchLayers?.graphics.length === 0 && graphic){
                    if(graphic.geometry?.type === 'polygon'){
                        const cen = (graphic.geometry as Polygon).centroid
                        globalLayers.userCurrentLocation = { lat:cen.latitude , lng: cen.longitude }
                        store.dispatch(setIsBuildingDrawn(false))
                        globalLayers.removePolyLineswithTitle('')
    
                        store.dispatch(setroofConfirmed(false))
                        globalLayers.roofConfirmed = false;
                        addMarkerToMap(store.dispatch)
                    }
                }
                
                
            }
            if(e.added.length > 0 && e.removed.length === 0){

                if(globalLayers.sketchLayers && globalLayers.sketchLayers?.graphics.length > 1){
                    // remove one graphic 

                }
                const graphic = e.added[0];
                
                if(graphic.geometry && graphic.geometry.type === 'polygon'){
                    const geodesicArea = geometryEngine.geodesicArea(graphic.geometry as Polygon, "square-meters");
                    const area = geodesicArea.toFixed(2)
                    if(parseFloat(area) < MINUSEABLEAREA || parseFloat(area) > MAXUSEABLEAREA){
                        globalLayers.sketchLayers?.graphics.remove(graphic);
                        globalLayers.removePolyLineswithTitle('')
                    }

                }
            }
        
        });

        (globalLayers.sketchVM as Sketch).watch('activeTool', (activeTool: TActiveTool) => {
            if(!activeTool){
                // the actibe tool is null or the active tool is rest
                globalLayers.hidePolyLines()
            }
           
        })
    }

}

const getLengthfromPolygonLines = async (newGraphic: any) => {
    const [Point, geodesicUtils ] = await loadMultipleModules(["esri/geometry/Point", "esri/geometry/support/geodesicUtils" ])

    const polygon = newGraphic.geometry;
    // esri/geometry/Point
    // const distanceInMeters = geometryEngine.distance(point1, point2);
    globalLayers.convertSpatialSystem(polygon).then((geom) => {
        let linesLength = [] as number[]
        if (geom) {
            let rings = geom.rings;
            const pairs = getPointPairsFromRing(rings[0]) as any[]

            pairs.forEach(ring => {
                // ring[0], ring[1]
                const point1 = {
                    latitude: ring[0][1],
                    longitude: ring[0][0],
                    type: "point"
                };

                const point2 = {
                    latitude: ring[1][1],
                    longitude: ring[1][0],
                    type: "point"
                };

                const join = geodesicUtils.geodesicDistance(
                    new Point({ x: point1.longitude, y: point1.latitude }),
                    new Point({ x: point2.longitude, y: point2.latitude }),
                    "meters"
                );

                linesLength.push(join.distance!)
            })

            return linesLength
        }
    })
}

async function getVertexAddEvent(event: __esri.SketchCreateEvent, Point: any, geodesicUtils: __esri.geodesicUtils, titleName: string, groupLayers: __esri.GroupLayer, geometryEngine: __esri.geometryEngine, Graphic: any) {
    if (event.state === "start" && event.toolEventInfo.type === "vertex-add" && event.tool === "circle") {
        lastAddedCoordinates = (event.toolEventInfo as any).added[0]
    }

    if (event.state === "active" && event.tool === "circle") {

        if (lastAddedCoordinates.length === 0) {
        } else {
            if (event.toolEventInfo.type === "cursor-update") {
                currentCoordinates = event.toolEventInfo.coordinates
            }
            if (event.toolEventInfo.type === "vertex-add") {
                currentCoordinates = event.toolEventInfo.vertices[0].coordinates
            }
        }

        if (lastAddedCoordinates.length > 0) {
            createPolylinewithCoordinates(geodesicUtils, Point, lastAddedCoordinates, currentCoordinates, titleName)
        }

    }

    // measurement guide lines for polygon drawing (handles undo/redo, cancel and completion)
    handlePolygonGuideEvent(event, titleName)
}
